import emailjs from '@emailjs/browser';

emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

export const sendContactEmail = async ({ name, email, phone, message }) => {
  const templateParams = {
    to_email: process.env.REACT_APP_CONTACT_EMAIL,
    from_email: process.env.REACT_APP_VERIFIED_SENDER_EMAIL,
    name: name,
    email: email,
    phone: phone || 'Not provided',
    message: message
  };

  try {
    await emailjs.send(
      'default_service', // Your EmailJS service ID
      'template_mh1m11n', // Your EmailJS template ID
      templateParams
    );
    return { success: true };
  } catch (error) {
    console.error('EmailJS error:', error);
    throw new Error('Failed to send email');
  }
};